






























import { BankAccountType, BankType, LoadingStatusType, PaymentInOutFlowType } from "@/enums/enums";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StorePayment = namespace("Payment");

@Component
export default class DropdownPaymentBankAccount extends Vue {
  @Prop({}) readonly paymentInOutFlowType!: PaymentInOutFlowType;
  @Prop({}) readonly paymentTransactionBankAccount!: any;
  @Prop({}) readonly paymentGroup!: any;
  @Prop({}) readonly transactionContact!: any;
  @Prop({}) readonly sequenceNumber!: number;
  @Prop({}) readonly label!: string;

  private options: any = [];
  private selectBankAccount: any = "";

  @StorePayment.Getter
  private getCashInBankAccountList!: any;
  @StorePayment.Getter
  private getCashOutBankAccountList!: any;
  @StorePayment.Getter
  private getBankReferenceLoadingStatus!: LoadingStatusType;

  @StorePayment.Action
  private DoGetAllMainBankAccount!: (isUseMainDatabase: boolean) => void;

  get bankAccountList() {
    if (this.paymentInOutFlowType === PaymentInOutFlowType.CashIn) {
      return this.getCashInBankAccountList;
    } else {
      return this.getCashOutBankAccountList;
    }
  }

  @Watch("paymentTransactionBankAccount.bankAccountId")
  bankAccountIdChanged() {
    if (this.getBankReferenceLoadingStatus === LoadingStatusType.Success) {
      this.DoMatchBankAccount();
    }
  }

  @Watch("getBankReferenceLoadingStatus", { immediate: true })
  bankAccountListLoadingStatusChanged() {
    if (this.getBankReferenceLoadingStatus === LoadingStatusType.Success) {
      this.options = [];
      this.bankAccountList.forEach((element: any) => {
        if (this.paymentInOutFlowType === PaymentInOutFlowType.CashIn && element.isCashIn) {
          this.options.push(element);
        } else if (this.paymentInOutFlowType === PaymentInOutFlowType.CashOut && element.isCashOut) {
          this.options.push(element);
        }
      });
      this.DoMatchBankAccount();
    } else if (this.getBankReferenceLoadingStatus === LoadingStatusType.None) {
      this.DoGetAllMainBankAccount(true);
    }
  }

  public DoMatchBankAccount() {
    let selectValue = null;
    if (this.paymentTransactionBankAccount.bankAccountId > 0) {
      selectValue = this.bankAccountList.find((x: any) => x.id === this.paymentTransactionBankAccount.bankAccountId);
    } else if (
      this.paymentTransactionBankAccount.bankAccountCode &&
      this.paymentTransactionBankAccount.bankAccountCode.length !== 0
    ) {
      selectValue = this.bankAccountList.find(
        (x: any) => x.code === this.paymentTransactionBankAccount.bankAccountCode
      );
    } else {
      selectValue = "";
    }
    this.SelectBankAccount(selectValue);
  }

  public SelectBankAccount(item: any) {
    if (item && item != "") {
      this.selectBankAccount = item;
      this.OnChangeBankAccount(item);
    } else {
      this.selectBankAccount = this.bankAccountList[0];
      this.OnChangeBankAccount(this.selectBankAccount);
    }
  }

  public OnChangeBankAccount(item: any) {
    this.paymentTransactionBankAccount.bankAccountCode = item.code;
    this.paymentTransactionBankAccount.bankAccountId = item.id;
    this.paymentTransactionBankAccount.bankAccountName = item.name;
    this.$emit("change");
  }
  public GetOptionName(props: any) {
    let bankAccountName = "";
    switch (props.bankAccountType) {
      case BankAccountType.Cash:
        bankAccountName = props.name;
        break;
      case BankAccountType.Bank:
        bankAccountName = `${props.bankName ? props.bankName : ""} ${this.GetBankAccountType(props.bankType)} - ${
          props.bankNumber ? props.bankNumber : ""
        } ${props.name ? props.name : ""}`;
        break;
      case BankAccountType.ExpenseClaim:
        bankAccountName = props.name;
        break;
      default:
        bankAccountName = props.name;
        break;
    }
    return bankAccountName;
  }

  public GetBankAccountType(bankAccountType: any) {
    let bankType: any = "";
    switch (bankAccountType) {
      case BankType.CurrentAccount:
        bankType = this.$t("Current_Account");
        break;
      case BankType.SavingAccount:
        bankType = this.$t("Saving_Account");
        break;
      case BankType.FixedDeposit:
        bankType = this.$t("Fixed_Deposit");
        break;
      default:
        bankType = "";
        break;
    }

    return bankType;
  }
}
